import { get } from '@api/api-client';
import {
  appendPaginationQuery,
  type PaginatedResponse,
  type PaginationParams,
} from '@api/pagination';

export interface UserResponse {
  id: string;
  email: string;
  name: string;
  surname: string;
  docplannerDoctorId: number | null;
  docplannerClinicId: number | null;
  countryId: string;
  countryCode: string;
  provider: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface UserFilterParams {
  email?: string;
  provider?: string;
  countryId?: string;
}

/** Fetches users with pagination. */
export function getUsers(params?: PaginationParams): Promise<PaginatedResponse<UserResponse>> {
  return get<PaginatedResponse<UserResponse>>(appendPaginationQuery('/users', params));
}

/** Fetches users with pagination and filters. */
export function listRegularUsers(
  params?: PaginationParams,
  filters?: UserFilterParams,
): Promise<PaginatedResponse<UserResponse>> {
  const parts: string[] = [];

  if (params?.page !== undefined) parts.push(`page=${params.page}`);
  if (params?.pageSize !== undefined) parts.push(`pageSize=${params.pageSize}`);
  if (filters?.email) parts.push(`email=${encodeURIComponent(filters.email)}`);
  if (filters?.provider) parts.push(`provider=${encodeURIComponent(filters.provider)}`);
  if (filters?.countryId) parts.push(`countryId=${encodeURIComponent(filters.countryId)}`);

  const query = parts.length > 0 ? `?${parts.join('&')}` : '';
  return get<PaginatedResponse<UserResponse>>(`/users${query}`);
}
